import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { ConfirmationModal } from '@acorns/web-components';

var ConfirmationModalFactory = function ConfirmationModalFactory(config, callbackOptions) {
  var _config$actions;

  var modifiedConfig = _objectSpread(_objectSpread({}, config), {}, {
    actions: (_config$actions = config.actions) === null || _config$actions === void 0 ? void 0 : _config$actions.map(function (action) {
      var _action$handler;

      return _objectSpread(_objectSpread({}, action), {}, {
        handler: action === null || action === void 0 ? void 0 : (_action$handler = action.handler) === null || _action$handler === void 0 ? void 0 : _action$handler.call(action, callbackOptions)
      });
    })
  });

  return function (_ref) {
    var isOpen = _ref.isOpen;
    return /*#__PURE__*/React.createElement(ConfirmationModal, _extends({}, modifiedConfig, {
      isOpen: isOpen,
      onRequestClose: callbackOptions.closeModal,
      onCloseComplete: callbackOptions.handleCloseComplete
    }));
  };
};

export { ConfirmationModalFactory };